<template>
  <div ref="containerRef" class="decoration-10-slow">
    <svg :width="width" :height="height">
      <!-- 背景完整横线 -->
      <polyline
        :stroke="mergedColor[1]"
        stroke-width="2"
        :points="`0, ${halfH} ${width}, ${halfH}`"
      />
      <!-- 段1：0% ~ 20% -->
      <polyline
        :stroke="mergedColor[0]"
        stroke-width="2"
        :points="`5, ${halfH} ${width * 0.2 - 3}, ${halfH}`"
        :stroke-dasharray="`0, ${width * 0.2}`"
        fill="freeze"
      >
        <animate
          :id="ani2"
          attributeName="stroke-dasharray"
          :values="`0, ${width * 0.2};${width * 0.2}, 0;`"
          :dur="segDur"
          :begin="`${ani1}.end`"
          fill="freeze"
        />
        <animate
          attributeName="stroke-dasharray"
          :values="`${width * 0.2}, 0;0, ${width * 0.2}`"
          dur="0.01s"
          :begin="`${ani7}.end`"
          fill="freeze"
        />
      </polyline>
      <!-- 段2：20% ~ 80% -->
      <polyline
        :stroke="mergedColor[0]"
        stroke-width="2"
        :points="`${width * 0.2 + 3}, ${halfH} ${width * 0.8 - 3}, ${halfH}`"
        :stroke-dasharray="`0, ${width * 0.6}`"
      >
        <animate
          :id="ani4"
          attributeName="stroke-dasharray"
          :values="`0, ${width * 0.6};${width * 0.6}, 0`"
          :dur="segDur"
          :begin="`${ani3}.end`"
          fill="freeze"
        />
        <animate
          attributeName="stroke-dasharray"
          :values="`${width * 0.6}, 0;0, ${width * 0.6}`"
          dur="0.01s"
          :begin="`${ani7}.end`"
          fill="freeze"
        />
      </polyline>
      <!-- 段3：80% ~ 100% -->
      <polyline
        :stroke="mergedColor[0]"
        stroke-width="2"
        :points="`${width * 0.8 + 3}, ${halfH} ${width - 5}, ${halfH}`"
        :stroke-dasharray="`0, ${width * 0.2}`"
      >
        <animate
          :id="ani6"
          attributeName="stroke-dasharray"
          :values="`0, ${width * 0.2};${width * 0.2}, 0`"
          :dur="segDur"
          :begin="`${ani5}.end`"
          fill="freeze"
        />
        <animate
          attributeName="stroke-dasharray"
          :values="`${width * 0.2}, 0;0, ${width * 0.3}`"
          dur="0.01s"
          :begin="`${ani7}.end`"
          fill="freeze"
        />
      </polyline>
      <!-- 4 个端点圆点 -->
      <circle :cx="2" :cy="halfH" r="2" :fill="mergedColor[1]">
        <animate
          :id="ani1"
          attributeName="fill"
          :values="`${mergedColor[1]};${mergedColor[0]}`"
          :begin="`0s;${ani7}.end`"
          dur="0.3s"
          fill="freeze"
        />
      </circle>
      <circle :cx="width * 0.2" :cy="halfH" r="2" :fill="mergedColor[1]">
        <animate
          :id="ani3"
          attributeName="fill"
          :values="`${mergedColor[1]};${mergedColor[0]}`"
          :begin="`${ani2}.end`"
          dur="0.3s"
          fill="freeze"
        />
        <animate
          attributeName="fill"
          :values="`${mergedColor[1]};${mergedColor[1]}`"
          dur="0.01s"
          :begin="`${ani7}.end`"
          fill="freeze"
        />
      </circle>
      <circle :cx="width * 0.8" :cy="halfH" r="2" :fill="mergedColor[1]">
        <animate
          :id="ani5"
          attributeName="fill"
          :values="`${mergedColor[1]};${mergedColor[0]}`"
          :begin="`${ani4}.end`"
          dur="0.3s"
          fill="freeze"
        />
        <animate
          attributeName="fill"
          :values="`${mergedColor[1]};${mergedColor[1]}`"
          dur="0.01s"
          :begin="`${ani7}.end`"
          fill="freeze"
        />
      </circle>
      <circle :cx="width - 2" :cy="halfH" r="2" :fill="mergedColor[1]">
        <animate
          :id="ani7"
          attributeName="fill"
          :values="`${mergedColor[1]};${mergedColor[0]}`"
          :begin="`${ani6}.end`"
          dur="0.3s"
          fill="freeze"
        />
        <animate
          attributeName="fill"
          :values="`${mergedColor[1]};${mergedColor[1]}`"
          dur="0.01s"
          :begin="`${ani7}.end`"
          fill="freeze"
        />
      </circle>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Decoration10Slow',
  props: {
    color: {
      type: Array,
      default: () => []
    },
    // 三段动画总时长（秒），每段 = dur / 3
    dur: {
      type: Number,
      default: 15
    }
  },
  data() {
    const uid = Math.random().toString(36).slice(2, 9)
    return {
      width: 0,
      height: 0,
      defaultColor: ['#00c2ff', 'rgba(0, 194, 255, 0.3)'],
      mergedColor: ['#00c2ff', 'rgba(0, 194, 255, 0.3)'],
      ani1: `d10a1${uid}`,
      ani2: `d10a2${uid}`,
      ani3: `d10a3${uid}`,
      ani4: `d10a4${uid}`,
      ani5: `d10a5${uid}`,
      ani6: `d10a6${uid}`,
      ani7: `d10a7${uid}`,
      resizeObserver: null
    }
  },
  computed: {
    halfH() {
      return this.height / 2
    },
    // 单段时长 = 总时长 / 3，三段紧密衔接共 dur 秒
    segDur() {
      return (this.dur / 3).toFixed(2) + 's'
    }
  },
  watch: {
    color: {
      deep: true,
      handler() {
        this.mergeColor()
      }
    }
  },
  mounted() {
    this.mergeColor()
    this.measure()
    this.resizeObserver = new ResizeObserver(() => this.measure())
    this.resizeObserver.observe(this.$refs.containerRef)
  },
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
  methods: {
    mergeColor() {
      const merged = [...this.defaultColor]
      if (this.color && this.color.length) {
        this.color.forEach((c, i) => { merged[i] = c })
      }
      this.mergedColor = merged
    },
    measure() {
      const el = this.$refs.containerRef
      if (!el) return
      this.width = el.clientWidth
      this.height = el.clientHeight
    }
  }
}
</script>

<style scoped>
.decoration-10-slow {
  width: 100%;
  height: 100%;
}
.decoration-10-slow svg {
  display: block;
}
</style>
